export default "__VITE_ASSET__CDO3UXl$__"